/**
 * Check if user is authenticated
 * @returns {boolean} True if user has a valid token
 */
export const isAuthenticated = () => {
  const token = window.localStorage.getItem('b2b-jwtToken') || window.localStorage.getItem('access_token');
  return !!token;
};

/**
 * Get current user data from localStorage
 * @returns {Object|null} User object or null
 */
export const getCurrentUser = () => {
  try {
    const userStr = window.localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    return null;
  }
};

/**
 * Clear authentication data and logout
 * @param {Function} navigate - Optional navigate function to redirect after logout
 */
export const logout = (navigate = null) => {
  window.localStorage.removeItem('b2b-jwtToken');
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('user');
  
  // Clear cart on logout (optional - you might want to keep it)
  // window.localStorage.removeItem('cart');
  
  if (navigate) {
    navigate('/');
  }
  
  // Force page reload to clear any cached state
  window.location.href = '/';
};

/**
 * Clear authentication data (alias for logout)
 */
export const clearAuth = logout;

export default {
  isAuthenticated,
  getCurrentUser,
  clearAuth,
  logout,
};

